import React from 'react'
import gsap from "gsap";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './inspire.css'
import ImageGrid from '../../common/ImageGrid'
import url1 from '../images/collage/collage1.jpg'
import url2 from '../images/collage/collage2.jpg'
import url3 from '../images/collage/collage3.jpg'
import url4 from '../images/collage/collage4.jpg'
import url5 from '../images/collage/collage5.jpg'
import url6 from '../images/collage/collage6.jpg'
import url7 from '../images/collage/collage7.jpg'
import url8 from '../images/collage/collage8.jpg'
import url9 from '../images/collage/collage9.jpg'
import url10 from '../images/collage/collage10.jpg'
import url11 from '../images/collage/collage11.jpg'
import url12 from '../images/collage/collage12.jpg'
import url13 from '../images/collage/collage13.jpg'
import url14 from '../images/collage/collage14.jpg'
import url15 from '../images/collage/collage15.jpg'
import url16 from '../images/collage/collage16.jpg'
import url17 from '../images/collage/collage17.jpg'
import url18 from '../images/collage/collage18.jpg'
import url19 from '../images/collage/collage19.jpg'
import url20 from '../images/collage/collage20.jpg'
import url21 from '../images/collage/collage21.jpg'
import url22 from '../images/collage/collage22.jpg'
import url23 from '../images/collage/collage23.jpg'
import url24 from '../images/collage/collage24.jpg'
import url25 from '../images/collage/collage25.jpg'
import url26 from '../images/collage/collage26.jpg'
import url27 from '../images/collage/collage27.jpg'
import url28 from '../images/collage/collage28.jpg'
import url29 from '../images/collage/collage29.jpg'
import url30 from '../images/collage/collage30.jpg'

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

const Inspire = (props) => {
    // console.log('props', props)
    const two = useRef(null);
    const inspire = useRef(null);

    // useGSAP(() => {
    //     const pTags = two.current.querySelectorAll("p");
    //     gsap.from(pTags, {
    //         scale: 1.2,
    //         opacity: 0,
    //         stagger: 1,
    //         duration: 1.9,
    //         ease: "elastic.out",
    //     });
    // });

    // useGSAP(() => {
    //     gsap.from(inspire.current, {
    //         opacity: 0,
    //         stagger: 0.1,
    //         delay: 0.2,
    //         duration: 10,
    //         ease: "elastic.out",
    //     });
    // });

    const imagesOld = [
        'https://i.pinimg.com/564x/d9/91/b0/d991b0a6503463a5468c413189fb6f95.jpg',
        'https://i.pinimg.com/564x/3f/f5/78/3ff578b974d31a15f2a255437cacc674.jpg',
        'https://i.pinimg.com/564x/6a/ae/8b/6aae8b1dd70c0a30b36f9f3015f3e98d.jpg',
        'https://i.pinimg.com/564x/a0/ac/8b/a0ac8b0f0949d43688e82e22bd9d25d8.jpg',
        'https://i.pinimg.com/564x/db/fa/6f/dbfa6f77e7cee7b6b8afc6374dc4745d.jpg',
        'https://i.pinimg.com/564x/ac/b5/b3/acb5b3ea231a9d40c959b62c959c218e.jpg',
        'https://i.pinimg.com/564x/61/ce/67/61ce67baba1d8d8f857b78e96f78bb0c.jpg',
        'https://i.pinimg.com/564x/ca/8f/9d/ca8f9df4ad89d1e2536a657fa20aa94c.jpg',
        'https://i.pinimg.com/564x/dc/63/5b/dc635bd346b2f6e8087c7e6717028a8e.jpg',
        'https://i.pinimg.com/564x/ac/b0/c2/acb0c24d8156716ba51b150deed8125c.jpg',
        'https://i.pinimg.com/564x/5d/8c/c7/5d8cc72e77ce3981e15e011c017eb71c.jpg',
        'https://i.pinimg.com/564x/a5/c7/6d/a5c76d6a7e80bdff9fa7f1b4b4074e23.jpg',
        'https://i.pinimg.com/564x/cd/e6/93/cde6937ced4ce53a4e87d80f2ecaea76.jpg',
        'https://i.pinimg.com/564x/ea/83/e8/ea83e8485b2ad357b1f1be28ac72d463.jpg'
        // Add more URLs here
    ];

    const images = [
        url1, url2, url3, url4, url5, url6, url7,
        url8, url9, url10, url11, url12, url13, url14,
        url15, url16, url17, url18, url19, url20, url21,
        url22, url23, url24, url25, url26, url27, url28,
    ];

    const colsStart = [
        1, 2, 3, 4, 5, 6, 7,
        1, 2, 3, 3, 5, 6, 7,
        1, 1, 3, 4, 5, 6, 7,
        1, 2, 2, 4, 5, 4, 7
    ]
    const colsEnd = [
        2, 3, 4, 5, 6, 8, 8,
        2, 3, 5, 6, 7, 7, 8,
        2, 4, 4, 5, 6, 7, 8,
        2, 4, 4, 5, 6, 6, 8
    ]

    const rowsStart = [
        1, 1, 1, 1, 1, 1, 3,
        6, 3, 4, 6, 3, 6, 6,
        9, 11, 8, 8, 8, 11, 9,
        13, 13, 16, 12, 10, 15, 11,
    ]
    const rowsEnd = [
        6, 3, 4, 4, 3, 3, 6,
        9, 11, 6, 8, 6, 11, 9,
        11, 13, 11, 12, 10, 16, 11,
        17, 16, 20, 15, 15, 20, 14,
    ]

    return (
        // <div className="App">
        //     <ImageGrid images={images} />
        // </div>

        // <div class="grid">
        //     <div class="grid-item1"></div>
        //     <div class="grid-item2"></div>
        //     <div class="grid-item3"></div>
        //     <div class="grid-item4"></div>
        //     <div class="grid-item5"></div>
        //     <div class="grid-item6"></div>
        //     <div class="grid-item7"></div>
        //     <div class="grid-item8"></div>

        //     <div class="grid-item9"></div>
        //     <div class="grid-item10"></div>
        //     <div class="grid-item11"></div>
        //     <div class="grid-item12"></div>
        //     <div class="grid-item13"></div>
        //     <div class="grid-item14"></div>
        //     <div class="grid-item15"></div>
        //     <div class="grid-item16"></div>

        //     <div class="grid-item17"></div>
        //     <div class="grid-item18"></div>
        //     <div class="grid-item19"></div>
        //     <div class="grid-item20"></div>
        //     <div class="grid-item21"></div>
        //     <div class="grid-item22"></div>
        //     <div class="grid-item23"></div>
        //     <div class="grid-item24"></div>

        //     <div class="grid-item25"></div>
        //     <div class="grid-item26"></div>
        //     <div class="grid-item27"></div>
        //     <div class="grid-item28"></div>
        //     <div class="grid-item29"></div>
        //     <div class="grid-item30"></div>
        // </div>


        <div className="grid">
            {images.map((image, index) => {
                const colStart = index + 1; // grid-column start
                const colEnd = colStart + 1; // grid-column end (next column)
                // console.log(colStart + "/" + colEnd)
                return (
                    <div
                        key={index}
                        className={`grid-item grid-item${index + 1}`}
                        style={{
                            backgroundImage: `url(${image})`,
                            gridColumn: `${colsStart[index]} / ${colsEnd[index]}`,
                            gridRow: `${rowsStart[index]} / ${rowsEnd[index]}`, // This remains constant
                        }}
                    ></div>
                );
            })}
        </div>

        // <div>
        //     <div className="container ourValuesContainer">
        //         <div className="section">
        //             <div ref={two}>
        //                 <p className='inspire'>About us</p>
        //                 {/* <h1 className='ourValues'>At Bandara Dashboards,
        //                     we're more than just a tech company -
        //                     we're car lovers, engineers, and designers,
        //                     committed to delivering solutions that honor
        //                     the soul of your vehicle and elevate the driving
        //                     experience to a whole new level.
        //                 </h1> */}
        //                 <h1 ref={inspire} className='ourValues'>We create custom instrument clusters using the next generation of Apple CarPlay. Our engineers and designers are car lovers at heart, bringing passion and expertise to every project.
        //                 </h1>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    );
}

export default Inspire